// Get tags here, tag count here
import { Alert, Button, Text } from '@change/ds-core-ui/next';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';

import { useAutoTaggedPetition } from './hooks/useAutoTaggedPetition';

export function AutoTaggedPetition() {
	const { data, actions } = useAutoTaggedPetition();

	return (
		<div className="flex h-full w-full gap-4 p-6 pb-0" data-qa="auto-tagged-petition-message">
			<Alert
				className="w-full [&>div>div]:flex-row"
				variant="info"
				heading={
					<TranslatePlural
						value="corgi.petition.starter_dashboard.notifications.auto_tagged_petition.title"
						replacements={{ numTags: data.numTags }}
						count={data.numTags}
					/>
				}
			>
				<Text as="p">
					<TranslatePlural
						value="corgi.petition.starter_dashboard.notifications.auto_tagged_petition.body"
						replacements={{ tags: data.tags.join(', ') }}
						count={data.numTags}
					/>
				</Text>
				<Button
					as="a"
					className="mt-4"
					data-testid="auto-tagged-petition-button"
					variant="secondary-solid"
					size="x-small"
					href={data.anchorLink}
					onClick={actions.handleEditTags}
				>
					<Translate value="corgi.petition.starter_dashboard.notifications.auto_tagged_petition.primary_action_button" />
				</Button>
			</Alert>
		</div>
	);
}
